import { colors } from '@lmc/common/constants'
import { Icon } from 'components/generic/Icon'
import { useState } from 'react'
import styled from 'styled-components'
import videoThumbnailPlaceholder from '../../../../../../../images/videoThumbnailPlaceholder.svg'

type VideoDisplayProps = {
  videoFile: string
  videoThumbnail?: string | null
  testId?: string
}

const VideoDisplay = ({
  videoFile,
  videoThumbnail,
  testId
}: VideoDisplayProps) => {
  const [isVideoOpen, setIsVideoOpen] = useState(false)

  const toggleVideoPopup = () => {
    setIsVideoOpen(!isVideoOpen)
  }

  const handleThumbnailClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    toggleVideoPopup()
  }

  const handleClose = (e: React.MouseEvent) => {
    toggleVideoPopup()
    e.stopPropagation()
  }

  return (
    <>
      <VideoThumbnailLink
        onClick={handleThumbnailClick}
        data-testid={testId ? `${testId}-video-thumbnail` : undefined}
      >
        <PlayIconContainer>
          <Icon name="play" fill={colors.white} size={32} />
        </PlayIconContainer>
        <VideoThumbnailImage
          src={
            videoThumbnail !== null ? videoThumbnail : videoThumbnailPlaceholder
          }
          alt="Video thumbnail"
        />
      </VideoThumbnailLink>

      {isVideoOpen && (
        <PopupBox onClick={handleClose}>
          <PopupContent onClick={(e) => e.stopPropagation()}>
            <CloseIcon onClick={handleClose}>×</CloseIcon>
            <Video controls>
              <source src={videoFile} type="video/mp4" />
              <track
                src="captions_en.vtt"
                kind="captions"
                label="english_captions"
              />
            </Video>
          </PopupContent>
        </PopupBox>
      )}
    </>
  )
}

const VideoThumbnailLink = styled.a`
  position: relative;
  display: inline-block;
  height: 72px;
  width: 58px;
  border-radius: 9px;
  margin-right: 8px;
  cursor: pointer;
  overflow: hidden;
`

const PlayIconContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  pointer-events: none;
`

const VideoThumbnailImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 9px;
`

const PopupBox = styled.div`
  position: fixed;
  background: #00000050;
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 10;
`

const PopupContent = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 70%;
  margin: 0 auto;
  max-height: 70vh;
  margin-top: calc(100vh - 85vh - 20px);
  background: ${colors.white};
  border-radius: 10px;
  padding: 20px;
  overflow: auto;
`

const CloseIcon = styled.span`
  cursor: pointer;
  position: fixed;
  right: calc(15% - 30px);
  top: calc(100vh - 85vh - 33px);
  background: ${colors.white};
  width: 25px;
  height: 25px;
  border-radius: 50%;
  line-height: 20px;
  text-align: center;
  font-size: 20px;
`

const Video = styled.video`
  width: 100%;
  max-height: 60vh;
  border-radius: 10px;
  background: ${colors.background};
  cursor: pointer;
`

export default VideoDisplay
